module.exports = __webpack_public_path__ + "media/mypage/images/icons/sp_map-06617a3b34b0ee19d8fc7e7d84548759.png";